export default __webpack_public_path__ + "static/animation_hero-c506d1358b8d109496f0d01969a45ae2.gif";